import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { UsersProvider } from '../../providers/Access/Users/UsersProvider';
import { AccessProfileProvider } from '../../providers/Access/AccessProfile/AccessProfileProvider';

interface Props {
    element?: any;
    path?: string;
}

export const UserRoute: FC<Props> = () => {
    return (
        <UsersProvider>
            <AccessProfileProvider>
                <Outlet />
            </AccessProfileProvider>
        </UsersProvider>
    );
}